<template>
  <v-dialog
    :value="isVisible"
    content-class="custom-dialog"
    persistent
    scrollable
    max-width="500px"
  >
    <SelectColumnsDialogContent
      v-show="isFirstStep"
      @change="onChangeHandler"
      @close="$emit('close')"
    />
    <ImportFileDialogContent
      v-if="!isFirstStep"
      :selected-columns="selectedColumns"
      @back="isFirstStep = true"
      @close="$emit('close'), (isVisible = false)"
    />
  </v-dialog>
</template>

<script>
import SelectColumnsDialogContent from "@/components/BusinessAddresses/SelectColumnsDialogContent";

export default {
  name: "EditFromFileDialog",
  components: {
    ImportFileDialogContent: () =>
      import("@/components/BusinessAddresses/ImportFileDialogContent"),
    SelectColumnsDialogContent
  },
  data() {
    return {
      isVisible: true,
      selectedColumns: null,
      isFirstStep: true
    };
  },

  methods: {
    onChangeHandler(selectedColumns) {
      this.selectedColumns = selectedColumns;
      this.isFirstStep = false;
    }
  }
};
</script>
